import { ClearPayMessageUI } from "./ClearPayMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";

export function ClearPayMessage({
  product,
  runtimeConfig,
  experiences,
}: Pick<StandardProps, "product" | "runtimeConfig" | "experiences">) {
  const showClearPayMessage =
    experiences?.showClearPayMessage !== undefined &&
    experiences.showClearPayMessage === "true";

  const {
    variant: {
      aliases: { skuId },
      price,
    },
    isSelected,
    variant,
  } = useVariant(product);

  if (!showClearPayMessage) {
    return null;
  }

  const activeVariant = ensureIsActiveVariant(variant);
  const isVariantInStoreOnly = !!activeVariant && isInStoreOnly(activeVariant);
  const productHasAlcohol = product.attributes?.some((attribute) =>
    JSON.stringify(attribute).toLowerCase().includes("alcohol"),
  ) as boolean | undefined;

  const shouldExcludeProduct = isVariantInStoreOnly || productHasAlcohol;

  if (shouldExcludeProduct) {
    return null;
  }

  return (
    <ClearPayMessageUI
      runtimeConfig={runtimeConfig}
      skuId={skuId}
      currentPrice={price?.value}
      isSelected={isSelected}
    />
  );
}
